import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';
import { registerReactComponent } from '@trp-beacon-ui-kit/foundation/react/register';
import { BeaconButton } from '@trp-beacon-ui-kit/foundation/components/beacon-button';
import { BeaconInputField } from '@trp-beacon-ui-kit/foundation/components/beacon-input-field';
import { BeaconRadioGroup } from '@trp-beacon-ui-kit/foundation/components/beacon-radio-group';
import { BeaconRadioButton } from '@trp-beacon-ui-kit/foundation/components/beacon-radio-button';
import { BeaconCheckbox } from '@trp-beacon-ui-kit/foundation/components/beacon-checkbox';
import { BeaconDropdown } from '@trp-beacon-ui-kit/foundation/components/beacon-dropdown';
import { BeaconIconButton } from '@trp-beacon-ui-kit/foundation/components/beacon-icon-button';
import { BeaconDatePicker } from '@trp-beacon-ui-kit/foundation/components/beacon-date-picker';
import { BeaconModal } from '@trp-beacon-ui-kit/foundation/components/beacon-modal';
import { BeaconError } from '@trp-beacon-ui-kit/foundation/components/beacon-error';
//import { BeaconTableHeader } from '@trp-beacon-ui-kit/foundation/components/beacon-table-header';
//import { BeaconTableRecord } from '@trp-beacon-ui-kit/foundation/components/beacon-table-record';
//import { BeaconTableStub } from '@trp-beacon-ui-kit/foundation/components/beacon-table-stub';
//import { BeaconTable } from '@trp-beacon-ui-kit/foundation/components/beacon-table';
import { BeaconTooltip } from '@trp-beacon-ui-kit/foundation/components/beacon-tooltip';
//import { projectName } from 'services/globals';


// This is the name of your project
const projectNamePrefix = 'lfe-ui';

//components
export const LFEBeaconButton = registerReactComponent(
  projectNamePrefix,
  BeaconButton
);

export const LFEBeaconInputField = registerReactComponent(
  projectNamePrefix,
  BeaconInputField
);
export const LFEBeaconDropdown = registerReactComponent(
  projectNamePrefix,
  BeaconDropdown
);
export const LFEBeaconCheckbox = registerReactComponent(
  projectNamePrefix,
  BeaconCheckbox
);
export const LFEBeaconDatePicker = registerReactComponent(
  projectNamePrefix,
  BeaconDatePicker
);
export const LFEBeaconTooltip = registerReactComponent(
  projectNamePrefix,
  BeaconTooltip
);
export const LFEBeaconError = registerReactComponent(
  projectNamePrefix,
  BeaconError
);
export const LFEBeaconRadioGroup = registerReactComponent(
  projectNamePrefix,
  BeaconRadioGroup
);
export const LFEBeaconRadioButton = registerReactComponent(
  projectNamePrefix,
  BeaconRadioButton
);
export const LFEBeaconModal = registerReactComponent(
  projectNamePrefix,
  BeaconModal
);
export const LFEBeaconIconButton = registerReactComponent(
  projectNamePrefix,
  BeaconIconButton
);
const Registry = {
  LFEBeaconButton,
  LFEBeaconInputField,
  LFEBeaconDropdown,
  LFEBeaconCheckbox,
  LFEBeaconDatePicker,
  LFEBeaconTooltip,
  LFEBeaconError,
  LFEBeaconRadioGroup,
  LFEBeaconRadioButton,
  LFEBeaconModal,
  LFEBeaconIconButton,
};

export default Registry;